import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { Boxes, Layers, Route, FileCheck2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const STATS = [
    { icon: Boxes, to: 3, suffix: "", label: "Live products shipped", sub: "NomiConnekt · Spice Route · GoNomikai", id: "products" },
    { icon: Layers, to: 6, suffix: "", label: "Service lines", sub: "Strategy to white-label delivery", id: "services" },
    { icon: Route, to: 4, suffix: "", label: "Step delivery process", sub: "Discover · Define · Build · Launch", id: "process" },
    { icon: FileCheck2, to: 100, suffix: "%", label: "Scope agreed upfront", sub: "Quote in writing before any build", id: "scope" },
];

const Counter = ({ to, suffix, testId }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-80px" });
    const reduce = useReducedMotion();
    const [value, setValue] = useState(reduce ? to : 0);

    useEffect(() => {
        if (!inView || reduce) return undefined;
        const controls = animate(0, to, {
            duration: 1.6,
            ease: [0.16, 1, 0.3, 1],
            onUpdate: (v) => setValue(Math.round(v)),
        });
        return () => controls.stop();
    }, [inView, to, reduce]);

    return (
        <span
            ref={ref}
            data-testid={testId}
            className="font-heading text-5xl font-medium tracking-tight text-[#1C1917] lg:text-6xl"
        >
            {value}
            <span className="text-gradient-ember">{suffix}</span>
        </span>
    );
};

export default function Stats() {
    return (
        <section className="relative bg-[#FDF7F2]" data-testid="stats-bar">
            <div className="mx-auto max-w-7xl px-6 py-20 lg:px-8 lg:py-24">
                <div className="grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
                    {STATS.map((s, i) => (
                        <Reveal key={s.id} delay={i * 0.1}>
                            <div
                                className="relative border-l-2 border-[#EDE3DA] pl-6 transition-colors duration-300 hover:border-[#CF4242]"
                                data-testid={`stat-${s.id}`}
                            >
                                <s.icon size={18} className="text-[#CF4242]" aria-hidden="true" />
                                <div className="mt-4">
                                    <Counter to={s.to} suffix={s.suffix} testId={`stat-${s.id}-value`} />
                                </div>
                                <p className="mt-2 font-heading text-base font-semibold text-[#1C1917]">
                                    {s.label}
                                </p>
                                <p className="mt-1 text-xs leading-relaxed text-[#8A807A]">{s.sub}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
